'use client';
const compare = (prev, current)=>prev.map((v, i)=>v === current[i]).indexOf(false) < 0;

export { compare };
//# sourceMappingURL=compare.js.map
